<script>
import {
  iButton,
  iButtonStyles,
  iButtonTypes,
  iButtonSizes,
  iIcon,
  iInlineInput,
  iSwitch,
} from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';

export default {
  components: {
    iButton,
    iIcon,
    iInlineInput,
    iSwitch,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    categoryName: {
      type: String,
      default: null,
    },
    actionName: {
      type: String,
      default: null,
    },
    itemName: {
      type: String,
      default: null,
    },
    buttonLabel: {
      type: String,
      default: null,
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
    showToggle: {
      type: Boolean,
      default: false,
    },
    toggleValue: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    nameEditable: {
      type: Boolean,
      default: true,
    },
    showDeleteButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      iButtonStyles,
      iButtonTypes,
      iButtonSizes,
      palette,
      itemEnabled: null,
    };
  },
  watch: {
    toggleValue: {
      handler: function (newValue) {
        this.itemEnabled = newValue;
      },
    },
  },
  mounted() {
    this.itemEnabled = this.toggleValue;
  },
  methods: {
    onBackButtonClick() {
      this.$emit('on-back-button-click');
    },
    onNameChange(evt) {
      this.$emit('on-name-change', evt.target.value);
    },
    onButtonClick(evt) {
      this.$emit('on-button-click', evt);
    },
    onDelete(evt) {
      this.$emit('on-delete', evt);
    },
    onPublicSwitchChange(evt) {
      this.$emit('on-enabled-toggle-change', evt);
    },
  },
};
</script>

<template>
  <div
    class="decision-engine-nav d-flex flex-row align-items-center i-px-11 i-py-8"
  >
    <i-button
      class="link-icon i-mr-6"
      :left-icon="'medium-arrows-left'"
      :type="iButtonTypes.NEUTRAL"
      :button-style="iButtonStyles.GHOST"
      :size="iButtonSizes.MEDIUM"
      data-testid="decision-engine-nav-back-button"
      @button-click="onBackButtonClick"
    ></i-button>

    <!-- data text -->
    <div class="text d-flex flex-grow-1 align-items-center i-gap-2">
      <i-inline-input
        v-if="editable && nameEditable"
        :model-value="itemName"
        class="name-input"
        @update:model-value="onNameChange"
      />
      <div v-else class="name-input">{{ itemName }}</div>
    </div>

    <!-- controls -->
    <div class="controls d-flex flex-row align-items-center i-gap-8">
      <template v-if="showToggle">
        <span class="i-text-subheading-2">{{
          itemEnabled ? 'Enabled' : 'Disabled'
        }}</span>
        <i-switch
          :model-value="itemEnabled"
          size="sm"
          data-testid="nav-enabled-toggle"
          @update:model-value="
            itemEnabled = $event;
            onPublicSwitchChange($event);
          "
        />
      </template>

      <!-- actions menu -->
      <i-button
        v-if="showDeleteButton"
        class="trigger-button i-radius-md"
        data-testid="document-actions-button"
        :type="iButtonTypes.NEUTRAL"
        :button-style="iButtonStyles.GHOST"
        :size="iButtonSizes.MEDIUM"
        left-icon="small-delete-bin-1"
        @button-click="onDelete()"
      />

      <!-- edit create button-->
      <i-button
        v-if="editable"
        :text="buttonLabel"
        :disabled="buttonDisabled"
        data-testid="decision-engine-nav-button"
        :size="iButtonSizes.MEDIUM"
        type="primary"
        @button-click="onButtonClick()"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.decision-engine-nav {
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: var(--base);
  border-bottom: 1px solid var(--border-neutral-subtle);

  .name-input :deep(input),
  .name-input {
    max-width: 800px;
    color: $light-neutral-120;
    font-size: 18px;
    font-weight: 600;
    line-height: 21px;
  }
}
</style>
